import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table } from "react-bootstrap";
import { CareersActions } from "../../redux";
import BasicPagination from "../../../pagination/BasicPagination";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { getAllCareersAsync, deleteCareersAsync } from "../../redux";
import { useIsAccessAllow } from "../../../users/redux";

const CareersTable = () => {
  const history = useHistory();
  const {
    isLoading,
    careersList,
    skip,
    limit,
    searchBy,
    searchText,
  } = useSelector((state) => state.careers, shallowEqual);

  useEffect(() => {
    dispatch(getAllCareersAsync(searchBy, searchText));
    // eslint-disable-next-line
  }, []);

  const dispatch = useDispatch();
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(CareersActions.setCareersBatchNumber(count));
  };

  const onEditClick = (data) => {
    history.push(`/hfdi_careers/edit-careers/${data?._id}`);
  };
  const onDeleteClick = (data) => {
    if (window.confirm("Are you sure you want to delete?")) {
      dispatch(deleteCareersAsync(data?._id));
      dispatch(getAllCareersAsync(searchBy, searchText));
    }
  };
  const isEditCareersAllow = useIsAccessAllow("hfdi_careers.edit_careers");
  const isDeleteAllow = useIsAccessAllow("hfdi_careers.delete_careers");
  const isViewLogAllow = useIsAccessAllow("hfdi_careers.view_log");

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          <div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Slug</th>
                  <th>Title</th>
                  <th>Created On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {careersList.records && careersList.records.length ? (
                  careersList.records.map((careersLists, index) => (
                    <tr key={index}>
                      <td>
                        <span>{skip * limit + (index + 1)}</span>
                      </td>
                      <td>
                        <span>{careersLists.slug}</span>
                      </td>
                      <td>
                        <span>
                          <span>{careersLists.title}</span>
                        </span>
                      </td>
                      <td>
                        <span>
                          {new Date(careersLists.createdOn).toLocaleString()}
                        </span>
                      </td>
                      <td>
                        {isViewLogAllow && (
                          <a
                            href={`/hfdi_careers_log/${careersLists._id}`}
                            target="_blank"
                            rel="noreferrer"
                            title="View Log"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                title="View Log"
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/custom/history.svg"
                                )}
                              />
                            </span>
                          </a>
                        )}

                        {isEditCareersAllow && (
                          <button
                            title="Edit"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            onClick={() => onEditClick(careersLists)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Write.svg"
                                )}
                              />
                            </span>
                          </button>
                        )}

                        {isDeleteAllow && (
                          <button
                            title="Delete"
                            className="btn btn-icon btn-light btn-hover-danger btn-sm"
                            onClick={() => onDeleteClick(careersLists)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-danger">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/General/Trash.svg"
                                )}
                              />
                            </span>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          {!isLoading && (
            <div className="row d-flex align-items-center mr-5 ml-5 mt-4">
              <div className="col-md-8 text-right mb-5 aspgntn">
                <BasicPagination
                  totalRecords={careersList.recordsTotal}
                  limit={limit}
                  batch={skip + 1}
                  onBatchChange={onPageChange}
                />
              </div>
              <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-right">
                Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
                {careersList.recordsTotal} Records
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CareersTable;
